import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './NumberSelect.css'

@CSSModules(styles, { allowMultiple: true })
export default class NumberSelect extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    value: PropTypes.number
  }

  render () {
    return (
      <div onClick={this.props.onClick} styleName="numberselect">
        <button disabled={this.props.disabled} styleName="numberselect-button" />
        <div data-value={this.props.disabled ? 0 : this.props.value} styleName="numberselect-indicator" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Select/NumberSelect.js